"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterChipWithMenuMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _Select = require("../../components/Select/Select.styles");
var _buttonStateMixin = require("../buttonStateMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _sizeMixin = require("../sizeMixin");
var _spacingMixin = require("../spacingMixin");
var _ChipMixin = require("./ChipMixin");
var toggledOnCSS = function toggledOnCSS(props) {
  var isToggledOn = props.isToggledOn;
  if (!isToggledOn) {
    return '';
  }
  return (0, _styledToken.default)({
    backgroundColorHover: 'Chip.pressed.backgroundColorHover',
    borderWidth: 'Chip.pressed.borderWidth',
    horizontalSpacing: 'Chip.pressed.horizontalSpacing',
    chevronPadding: "Chip.pressed.chevronPadding",
    chevronPosX: "Chip.pressed.chevronPosX"
  }, function (_ref) {
    var backgroundColorHover = _ref.backgroundColorHover,
      borderWidth = _ref.borderWidth,
      chevronPadding = _ref.chevronPadding,
      chevronPosX = _ref.chevronPosX,
      horizontalSpacing = _ref.horizontalSpacing;
    return (0, _styledComponents.css)(["", "", "", "{border-width:", "px;padding-top:0;padding-right:", "px;padding-bottom:0;padding-left:", "px;background-position:right -", "px center;", " ", ";}"], _Select.StyledSelect, _Select.StyledSelect, _Select.StyledSelect, borderWidth, chevronPadding, horizontalSpacing, chevronPosX, (0, _buttonStateMixin.buttonStateMixin)('Pressed')(Object.assign({
      buttonType: 'tertiary'
    }, props)), (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n          background-color: " + backgroundColorHover + ";\n        "));
  })(props);
};
var iconCSS = function iconCSS(props) {
  var icon = props.icon,
    isToggledOn = props.isToggledOn;
  if (!icon) {
    return '';
  }
  return (0, _styledToken.default)({
    chevronPadding: "Chip.chevronPadding",
    iconPosX: "Chip.pressed.iconPosX",
    pressedChevronPadding: "Chip.pressed.chevronPadding"
  }, function (_ref2) {
    var chevronPadding = _ref2.chevronPadding,
      iconPosX = _ref2.iconPosX,
      pressedChevronPadding = _ref2.pressedChevronPadding;
    return (0, _styledComponents.css)(["", "{position:absolute;top:50%;left:", "px;transform:translateY(-50%);}", "", "", "", "{padding-left:", "px;}"], _Icon.StyledIcon, iconPosX, _Select.StyledSelect, _Select.StyledSelect, _Select.StyledSelect, _Select.StyledSelect, isToggledOn ? pressedChevronPadding : chevronPadding);
  })(props);
};

/** @class FilterChipWithMenuMixin */
/** @method */
var FilterChipWithMenuMixin = function FilterChipWithMenuMixin(props) {
  return (0, _styledToken.default)({
    borderWidth: "Chip.borderWidth",
    chevronPadding: "Chip.chevronPadding",
    chevronPosX: "Chip.chevronPosX",
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref3) {
    var borderWidth = _ref3.borderWidth,
      chevronPosX = _ref3.chevronPosX,
      chevronPadding = _ref3.chevronPadding,
      fontType = _ref3.fontType,
      height = _ref3.height;
    return (0, _styledComponents.css)(["max-width:100%;position:relative;", "{", " justify-content:left;max-width:100%;padding-right:", "px;text-overflow:ellipsis;width:auto;", " ", " ", " &:active:not(:disabled){", "}&:active,&:hover,&:disabled,&:focus,&{background-position:right -", "px center;}}", " ", " ", ""], _Select.StyledSelect, (0, _ChipMixin.ChipMixin)(props), chevronPadding, (0, _buttonStateMixin.buttonStateMixin)()(Object.assign({
      buttonType: 'tertiary'
    }, props)), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)((0, _buttonStateMixin.buttonStateMixin)('Hover')(Object.assign({
      buttonType: 'tertiary'
    }, props))), (0, _buttonStateMixin.buttonStateMixin)('Active')(Object.assign({
      buttonType: 'tertiary'
    }, props)), chevronPosX, (0, _spacingMixin.spacingMixin)(props), iconCSS(props), toggledOnCSS(props));
  })(props);
};
exports.FilterChipWithMenuMixin = FilterChipWithMenuMixin;